module.exports = __webpack_public_path__ + "static/media/prioritize.000ab821.svg";